import { reactive } from 'vue'

export default {
	install(app: any) {
		let currentUrlPath = ''
		const languageSource =
			window.BUYANDSHIP.settings.all_countries[
				window.BUYANDSHIP.settings.current_country2.id
			].languages
		const currentLanguageObj =
			languageSource[window.BUYANDSHIP.settings.current_language]
		const languageMap: {
			[key: string]: {
				name: string
				url: string
			}
		} = {}
		const state = reactive({
			currentLanguageName: '',
			languageMap: {},
		})

		app.config.globalProperties.$languageData = state

		generateData()

		function generateData() {
			currentUrlPath = ''
			if (import.meta.env.PROD) {
				currentUrlPath = window.location.href.replace(
					currentLanguageObj.url,
					'',
				)
			}
			if (window.location.origin.includes('test-') || !import.meta.env.PROD) {
				currentUrlPath = window.location.href.replace(
					window.location.origin,
					'',
				)
			}
			Object.keys(languageSource).forEach(iso => {
				let targetURL = languageSource[iso].url + currentUrlPath
				if (window.BUYANDSHIP.settings.blog_current_category2) {
					if (window.BUYANDSHIP.settings.blog_current_category2[iso]) {
						targetURL = `${languageSource[iso].url.replace(
							/\/$/,
							'',
						)}/blog/categories/${
							window.BUYANDSHIP.settings.blog_current_category2[iso]
						}`
					}
				}
				languageMap[iso] = {
					name: languageSource[iso].name,
					url: targetURL,
				}
			})
			state.currentLanguageName = currentLanguageObj.name
			state.languageMap = languageMap
		}

		window.history.pushState = (f =>
			function pushState(...args) {
				// @ts-ignore
				const ret = f.apply(this, args)
				window.dispatchEvent(new Event('pushstate'))
				window.dispatchEvent(new Event('locationchange'))
				return ret
			})(window.history.pushState)

		window.history.replaceState = (f =>
			function replaceState(...args) {
				// @ts-ignore
				const ret = f.apply(this, args)
				window.dispatchEvent(new Event('replacestate'))
				window.dispatchEvent(new Event('locationchange'))
				return ret
			})(window.history.replaceState)

		window.addEventListener('popstate', () => {
			window.dispatchEvent(new Event('locationchange'))
		})

		window.addEventListener('locationchange', generateData)
	},
}
